import { decode, encode } from 'uint8-to-base64';
import { AuthEndpoint } from './Auth';
export class EncodedEndpoint extends AuthEndpoint {
    async getRequestInit(body) {
        return super.getRequestInit(JSON.stringify(encode(body)));
    }
    process(value, ..._args) {
        if (value === null || value === undefined) {
            throw new Error('Empty response from server (204 No Content)');
        }
        return decode(value);
    }
}
